import { createUseStyles } from 'react-jss';
import constants from 'data/constants';

const useHeaderStyles = createUseStyles({
  headerContainer: {
    background: '#fff',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    zIndex: 1000,
    left: props => (props.width < constants.TABLET_WIDTH ? '80px' : '200px'),
    right: 0
  },
  subHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '20px'
  },
  subPageHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  }
});

export default useHeaderStyles;
